import { render } from "./FlutterwaveAddBank.vue?vue&type=template&id=261bf6a6&scoped=true"
import script from "./FlutterwaveAddBank.vue?vue&type=script&lang=js"
export * from "./FlutterwaveAddBank.vue?vue&type=script&lang=js"

import "./FlutterwaveAddBank.vue?vue&type=style&index=0&id=261bf6a6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261bf6a6"]])

export default __exports__